enum RoboticMowerSocketReasonConstants {
  UNDEFINED = 'UNDEFINED',
  PARK_COMMAND_SUCCESS = 'PARK_COMMAND_SUCCESS',
  PARK_COMMAND_FAIL = 'PARK_COMMAND_FAIL',
  START_COMMAND_SUCCESS = 'START_COMMAND_SUCCESS',
  START_COMMAND_FAIL = 'START_COMMAND_FAIL',
  SET_CUTTING_HEIGHT_COMMAND_FAIL = 'SET_CUTTING_HEIGHT_COMMAND_FAIL',
  SET_SCHEDULE_COMMAND_FAIL = 'SET_SCHEDULE_COMMAND_FAIL',
  UPDATE_MISSION_COMMAND_SUCCESS = 'UPDATE_MISSION_COMMAND_SUCCESS',
  UPDATE_MISSION_COMMAND_FAIL = 'UPDATE_MISSION_COMMAND_FAIL',
  UPDATE_SETTINGS_COMMAND_SUCCESS = 'UPDATE_SETTINGS_COMMAND_SUCCESS',
  UPDATE_SETTINGS_COMMAND_FAIL = 'UPDATE_SETTINGS_COMMAND_FAIL',
  REQUIRE_PIN_AFTER_STOP_COMMAND_SUCCESS = 'REQUIRE_PIN_AFTER_STOP_COMMAND_SUCCESS',
  REQUIRE_PIN_AFTER_STOP_COMMAND_FAIL = 'REQUIRE_PIN_AFTER_STOP_COMMAND_FAIL',
  ALARM_DURATION_COMMAND_SUCCESS = 'ALARM_DURATION_COMMAND_SUCCESS',
  ALARM_DURATION_COMMAND_FAIL = 'ALARM_DURATION_COMMAND_FAIL',
  CARRIED_AWAY_COMMAND_SUCCESS = 'CARRIED_AWAY_COMMAND_SUCCESS',
  CARRIED_AWAY_COMMAND_FAIL = 'CARRIED_AWAY_COMMAND_FAIL',
  STOP_BUTTON_PRESSED_COMMAND_SUCCESS = 'STOP_BUTTON_PRESSED_COMMAND_SUCCESS',
  STOP_BUTTON_PRESSED_COMMAND_FAIL = 'STOP_BUTTON_PRESSED_COMMAND_FAIL',
  GEO_FENCE_CENTRAL_POINT_COMMAND_SUCCESS = 'GEO_FENCE_CENTRAL_POINT_COMMAND_SUCCESS',
  GEO_FENCE_CENTRAL_POINT_COMMAND_FAIL = 'GEO_FENCE_CENTRAL_POINT_COMMAND_FAIL',
  GEO_FENCE_RADIUS_COMMAND_SUCCESS = 'GEO_FENCE_RADIUS_COMMAND_SUCCESS',
  GEO_FENCE_RADIUS_COMMAND_FAIL = 'GEO_FENCE_RADIUS_COMMAND_FAIL',
  GEO_FENCE_ENABLED_COMMAND_SUCCESS = 'GEO_FENCE_ENABLED_COMMAND_SUCCESS',
  GEO_FENCE_ENABLED_COMMAND_FAIL = 'GEO_FENCE_ENABLED_POINT_COMMAND_FAIL',
}

export default RoboticMowerSocketReasonConstants;
